var CustomCheckboxField = function (config) {
  jsGrid.Field.call(this, config);
};

var $controller = $(".data-grid").closest(".govuk-main-wrapper");

function _currentPage() {
  return $controller.find(".jsgrid").jsGrid("option", "pageIndex");
}

function _shouldPaginate() {
  return $controller.find(".jsgrid").jsGrid("option", "paging");
}

CustomCheckboxField.prototype = new jsGrid.Field({
  css: "table-checkbox",

  $headerCheckbox: undefined,

  selectedItems: [],

  headerTemplate: function () {
    // Initilisation for variables for later use
    var $input,
      currentPage,
      isChecked,
      page,
      pageCount,
      selectionModel,
      _self = this,
      headerCheckboxId = "headerCheckbox";

    // Checkbox definition
    $input = $(
      '<input type="checkbox" id="' +
        headerCheckboxId +
        '" name="' +
        headerCheckboxId +
        '" value="selectAllItems" aria-label="Select all items"/>',
    );

    // Assume that if the 'title' is provided for a 'checkbox' definition, the expectation is that it appears alongside the checkbox
    if (_self.title) {
      $input = $(
        '<label for="' + $input.attr("id") + '">' + _self.title + "</label>",
      ).append($input.addClass("visually-hidden"));
    }

    // Caching reference to this for dependent checkboxes to access
    _self.$headerCheckbox = $input;

    pageCount = window.DCLG.pageCount;
    isChecked = $input.is(":checked");

    // Event listeners
    $input.on("click", _selectAllClickEvent);
    $controller.on("dclg.dataGrid.selection.clear", _selectAllClearEvent);
    $controller.on("dclg.dataGrid.selection.change", _updateCheckedState);
    $controller.on(
      "dclg.checkboxlist.model.update",
      this._updateCheckboxListModel.bind(this),
    );

    // Initialise checkbox model
    _updateCheckboxHeaderModel(isChecked);

    // Use the Web API for 'sessionStorage': clean and set...

    // console.log('HeaderTemplate', JSON.parse(sessionStorage.getItem('sel')));

    return $input;

    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

    // Functions - custom and internal to 'headerTemplate'
    function _selectAllClickEvent(event) {
      isChecked = $input.is(":checked");
      _updateCheckboxHeaderModel(isChecked);

      var headerCheckboxToggler = {
        currentPage: currentPage,
        headerCheckboxIsChecked: isChecked,
      };

      // console.log(' ************ TOGGLER, for toggling all checkboxes on current page', headerCheckboxToggler);
      $controller.trigger(
        "dclg.dataGrid.selectAll.toggle",
        headerCheckboxToggler,
      );
    }

    function _selectAllClearEvent(event) {
      $input.prop("checked", false);
    }

    function _checkboxCount() {
      return selectionModel.unselected.length + selectionModel.selected.length;
    }

    function _updateCheckboxHeaderModel(_isChecked) {
      // Initialise/Get 'selection' model, for tracking checkbox selections...
      selectionModel = JSON.parse(sessionStorage.getItem("sel")) || {};

      // cache state of headerCheckbox in the selection Model
      selectionModel[headerCheckboxId] = _isChecked;
      selectionModel["selected"] = selectionModel["selected"] || [];
      selectionModel["unselected"] = selectionModel["unselected"] || [];

      sessionStorage.setItem("sel", JSON.stringify(selectionModel));
    }

    // Set the header checkbox to 'selected' if all rows have been manually selected
    function _updateCheckedState(event) {
      selectionModel = JSON.parse(sessionStorage.getItem("sel"));
      // currentPage = 'page_' + _currentPage();
      isChecked = selectionModel[headerCheckboxId];

      // console.log('>>>>>>>> HEADER_CHECKBOX: checking model to see if should update self...');

      var allSelected =
        $.isArray(selectionModel.unselected) &&
        $.isEmptyObject(selectionModel.unselected);
      // console.log('allSelected', allSelected);

      if ((allSelected && !isChecked) || (!allSelected && isChecked)) {
        isChecked = allSelected;

        $input.prop("checked", isChecked);
        _updateCheckboxHeaderModel(isChecked);
        // console.log('>>>>>>>> HEADER_CHECKBOX: updated!.');
      } else {
        // console.log('>>>>>>>> HEADER_CHECKBOX: did not need update.');
      }
    }
  },

  itemTemplate: function (value, row) {
    var $input,
      checkboxId,
      currentPage,
      inputStateChanged,
      model,
      selected,
      unselected,
      _self = this;

    // Fetch the checkbox model
    model = JSON.parse(sessionStorage.getItem("sel"));

    // Test, just to be sure...
    if ($.isEmptyObject(model)) {
      model = {};
    }

    // set/initialise state containers (for SELECTED and UNSELECTED checkboxes) for the current page
    // currentPage = 'page_' + _currentPage();
    // model[currentPage] =  model[currentPage] || {};

    selected = model["selected"];
    unselected = model["unselected"];

    // Save/Set the model
    sessionStorage.setItem("sel", JSON.stringify(model));

    // Checkbox definition... Ref: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox
    checkboxId = "grid_checkbox_" + row.id;

    $input = $(
      '<input type="checkbox" id="' +
        checkboxId +
        '" name="selectedItems" value="' +
        row.id +
        '" aria-label="selected item"/>',
    );

    //
    // Event Listeners
    //===================

    $input.on("change", _changeEventHandler);
    $controller.on(
      "dclg.dataGrid.selectAll.toggle",
      _toggleEventHandler.bind(_self),
    );

    // Event: for clearing the checkbox when a 'clear' event is fired from the facets
    $controller.on(
      "dclg.dataGrid.selection.clear",
      _clearSelectionsEventHandler,
    );

    //
    // State + Model initialisations
    //====================================

    // For clientside pagination the header checkbox takes priority
    // over setting the model and initial checkstate.

    if (selected.indexOf($input.attr("id")) > -1) {
      _render(true);
    } else {
      _render(false);
    }

    // console.log('Geronimo', unselected);
    // if (_self.$headerCheckbox.is(':checked')) {
    //     console.log('headerCheckbox', _self.$headerCheckbox);

    //     _setCheckState(true);
    //     _setModel();
    // } else if (model[row.id]) {
    //     _setCheckState(model[row.id]);
    // } else {
    //     _setModel();
    // }

    return $input;

    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^6

    // Internal functions //
    // =====================
    function _updateModel() {
      if (!_currentPage() && _shouldPaginate()) {
        // throw an Error as this is not right...
      } else {
        _reviewState($input.is(":checked"), $input.attr("id"), $input);
      }
    }

    function _render(checkedState) {
      _setCheckState(checkedState);
      _updateModel();
      if (inputStateChanged) {
        // $input.trigger('change');

        // Notify the Controller about the updated model
        $controller.trigger("dclg.dataGrid.selection.change");
      }
    }

    function _reviewState(isChecked, id, $checkbox) {
      model = JSON.parse(sessionStorage.getItem("sel"));
      // currentPage = 'page_' + _currentPage();

      // Remove from 'unselected' and put into 'selected'
      // $checkbox.trigger('change'); // it is SELECTED and IS NOT in the selected-pile
      // Remove from 'selected' and put into 'unselected'
      // $checkbox.trigger('change'); // it is UNSELECTED and IS NOT in the unselected-pile
      unselected = model["unselected"];
      selected = model["selected"];

      // Booleans
      var IS_MARKED_SELECTED = selected.indexOf(id) > -1,
        IS_NOT_MARKED_SELECTED = selected.indexOf(id) == -1,
        IS_MARKED_UNSELECTED = unselected.indexOf(id) > -1,
        IS_NOT_MARKED_UNSELECTED = unselected.indexOf(id) == -1;

      if (isChecked && IS_NOT_MARKED_SELECTED) {
        selected.push(id);

        if (IS_MARKED_UNSELECTED) {
          unselected.splice(unselected.indexOf(id), 1);
          inputStateChanged = true;
          //                    console.log('TOGGLED: unselected -> selected');
        }
      } else if (!isChecked && IS_NOT_MARKED_UNSELECTED) {
        unselected.push(id);

        if (IS_MARKED_SELECTED) {
          selected.splice(selected.indexOf(id), 1);
          inputStateChanged = true;
          //                    console.log('TOGGLED: selected -> unselected');
        }
      } else {
        inputStateChanged = false;
        // isChecked = IS_MARKED_SELECTED ? true : false;
        // $checkbox.prop('checked', isChecked);

        // console.log('STATE_UNTOUCHED', {
        //     isChecked: isChecked,
        //     isMarkedSelected: IS_MARKED_SELECTED,
        //     isNotMarkedSelected: IS_NOT_MARKED_SELECTED,
        //     isMarkedUnselected: IS_MARKED_UNSELECTED,
        //     isNotMarkedUnselected: IS_NOT_MARKED_UNSELECTED,
        //     id: id
        // });
      }

      sessionStorage.setItem("sel", JSON.stringify(model));
    }

    function _setCheckState(isChecked) {
      $input.prop("checked", isChecked);
    }

    function _changeEventHandler() {
      _render($input.is(":checked"));
    }

    function _toggleEventHandler(event, toggler) {
      // Move around the selections in one sweep
      model = JSON.parse(sessionStorage.getItem("sel"));

      // // Check the Grid to see if its data has changed and update the list
      // // we currently maintain in 'sel'
      // model.unselected = this._getCurrentCheckboxList();

      if (toggler.headerCheckboxIsChecked === true) {
        model.selected = this._sanitiseForDuplicates(
          model.selected,
          model.unselected,
        );
        model.unselected = [];
      } else {
        model.unselected = this._sanitiseForDuplicates(
          model.unselected,
          model.selected,
        );
        model.selected = [];
      }

      sessionStorage.setItem("sel", JSON.stringify(model));

      // if (toggler.currentPage === currentPage) {

      console.log(
        "___________________________________________________________",
      );
      console.log("TOGGLE ATTEMPT: starting...", {
        // currentPage: currentPage,
        checkbox: $input.attr("id"),
        togglerIsChecked: toggler.headerCheckboxIsChecked,
      });

      _setCheckState(toggler.headerCheckboxIsChecked);
      $controller.trigger("dclg.dataGrid.selection.change");

      // }
    }

    function _clearSelectionsEventHandler() {
      _render(false);
    }
  },

  insertTemplate: function (value) {
    return (this._insertPicker = this._createCheckbox());
  },

  editTemplate: function (value) {
    return (this._editPicker = this._createCheckbox());
  },

  insertValue: function () {
    return this._insertPicker;
  },

  editValue: function () {
    return this._editPicker;
  },

  _createCheckbox: function () {
    return $("<input>").attr("type", "checkbox");
  },

  _createCheckboxID: function (rowID) {
    // Process the RowModel for fetch an ID for the checkbox...
  },

  _updateCheckboxListModel: function (e) {
    var model = JSON.parse(sessionStorage.getItem("sel"));

    if ($.isArray(model.updatedData)) {
      model["unselected"] = this._getCurrentCheckboxList(model.updatedData);
      model["selected"] = [];
      // console.log('Apache'); //, JSON.parse(JSON.stringify(model)));
      delete model.updatedData;
    } else {
    }

    sessionStorage.setItem("sel", JSON.stringify(model));
  },

  _getCurrentCheckboxList: function (newData) {
    return $.map(newData, function (row, index) {
      return "grid_checkbox_" + row.id;
    });
  },

  _sanitiseForDuplicates: function () {
    // ------------------------------
    // Ref: https://stackoverflow.com/questions/31929074
    // -----------------------------
    return [].concat.apply([], arguments).reduce(function (result, current) {
      //If my result array doesn't get current element
      return result.indexOf(current) === -1
        ? //concat current element to result and return it
          result.concat(current)
        : //Otherwise, just return actual result array
          result;
    }, []);
  },
});

// @todo Implement functions below for selecting and manipulating table rows via checkboxes

module.exports = CustomCheckboxField;
